import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await register(form.name, form.email, form.password);
      toast.success("Conta criada com sucesso.");
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="relative w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-md bg-slate-900 grid place-items-center text-white font-heading font-bold">R</div>
          <span className="font-heading text-lg font-semibold tracking-tight">Ruma Flow</span>
        </div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight text-slate-900">Criar conta</h1>
        <p className="text-sm text-slate-500 mt-1">Comece em poucos segundos.</p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="register-form">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Nome</label>
            <input required data-testid="register-name-input" value={form.name} onChange={change("name")}
              className="w-full h-10 rounded-lg border border-slate-200 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">E-mail</label>
            <input type="email" required data-testid="register-email-input" value={form.email} onChange={change("email")}
              className="w-full h-10 rounded-lg border border-slate-200 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Senha</label>
            <input type="password" required minLength={6} data-testid="register-password-input" value={form.password} onChange={change("password")}
              className="w-full h-10 rounded-lg border border-slate-200 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent" />
            <p className="text-xs text-slate-500 mt-1">Mínimo 6 caracteres.</p>
          </div>
          {error && <div data-testid="register-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
          <button type="submit" disabled={submitting} data-testid="register-submit-button"
            className="w-full h-10 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 disabled:opacity-50">
            {submitting ? "Criando..." : "Criar conta"}
          </button>
        </form>
        <p className="text-sm text-slate-500 mt-6 text-center">
          Já tem conta? <Link to="/login" className="text-slate-900 font-medium hover:underline">Entrar</Link>
        </p>
      </div>
    </div>
  );
}
